import { ApiService } from "../api";
import { Opportunity } from "./";

/**
 * Functions for fetching opportunites.
 */
export class OpportunityService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	/**
	 * Find all opportunities for a given account
	 *
	 * @param accountId
	 * @param budgetId the budget being edited, if any, so opportunities already
	 *                 paying towards a different budget come back marked
	 */
	public async findByAccount(
		accountId: string,
		budgetId?: number | null,
	): Promise<Opportunity[]> {
		return this.getOpportunities(
			`for-account/${accountId}`,
			budgetId ? { budget: budgetId } : undefined,
		);
	}

	private async getOpportunities(
		endpoint: string,
		params?: object,
	): Promise<Opportunity[]> {
		const opportunityData = await this.apiService.get(
			`/api/v1/opportunities/${endpoint}`,
			params,
		);
		const opportunities = await opportunityData.json();

		return Opportunity.fromJsonArray(opportunities);
	}
}
